import { Component, OnInit } from '@angular/core';
import { Equipement } from 'app/Shared/models/equipement.model';
import { EquipementService } from 'app/Shared/Services/equipement.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { InterventionService } from 'app/Shared/Services/intervention.service';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})
export class ReportingComponent implements OnInit {
  equipements : Equipement [];
  spinner = true;
  selectedEquipment:Equipement;

  constructor(private route: ActivatedRoute,private equipementService : EquipementService,
              private interventionService:InterventionService
              ) { }

  ngOnInit(): void {
    this.selectedEquipment = {} as Equipement;
    const routeParams = this.route.snapshot.paramMap;
    const floorIdFromRoute = Number(routeParams.get('id'));
    const roomNameFromRoute = String(routeParams.get('name'));
    console.log(floorIdFromRoute,roomNameFromRoute)
    if(floorIdFromRoute && roomNameFromRoute){
      this.getEquipementsByFloorIdAndRoomName(floorIdFromRoute,roomNameFromRoute);
    }else{
      this.spinner=true
    }

    
  }
  passBack(equipement:Equipement){
    //console.log(equipement)
  }
  report(equipement:Equipement){
    const btn = document.getElementById(equipement.equipmentId.toString()) as HTMLButtonElement | null;
    btn?.setAttribute('disabled', '');
    this.interventionService.createEquipmentIntervention(equipement.equipmentId).subscribe(
      next=>{
        console.log(next)
      },error=>{
        console.log(error)
      }
    )

  }

  getEquipementsByFloorIdAndRoomName(floorId:number,roomName:string){
    this.equipementService.getEquipementsByFloorAndRoomName(floorId,roomName).subscribe(
      next=>{
        //console.log(next as Equipement)
        this.equipements=next as Equipement []
        this.spinner=false
      },error=>{
        console.log(error)
        this.spinner=true
      }
    )
  }

}
